/** Coinranking REST API v2 — базовий URL (не в компонентах таблиці). */
export const COINRANKING_API_BASE = "https://api.coinranking.com/v2";

export const COINRANKING_COINS_PATH = `${COINRANKING_API_BASE}/coins`;

/** Таблиця Market: top 100, період 24h (Free plan). */
export const MARKETS_COINRANKING_QUERY = {
  limit: 100,
  timePeriod: "24h",
};
